(function () {

  /* =========================================================
     VIDEO PRODUS – autoplay curat, forțat (Shopify Web Components)
     ========================================================= */
  function initProductVideos() {

    function setup(video) {
      if (video.dataset.entinoInit) return;
      video.dataset.entinoInit = 'true';

      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.playsInline = true;
      video.loop = true;

      const wrapper = video.closest('.js-product-media-item-deferred-video');

      // click pe VIDEO sau WRAPPER = play / pause
      (wrapper || video).addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });

      observer.observe(video);
    }

    function setupDeferred(wrapper) {
      if (!wrapper || wrapper.dataset.entinoDeferredInit) return;
      wrapper.dataset.entinoDeferredInit = 'true';

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          if (typeof wrapper.loadContent === 'function' && !wrapper.hasAttribute('loaded')) {
            wrapper.loadContent();
          } else if (!wrapper.hasAttribute('loaded')) {
            wrapper.querySelector('.js-product-media-item-deferred-video-image')?.click();
          }

          const video = wrapper.querySelector('video.js-media-item-video');
          if (video) {
            setup(video);
            video.play().catch(function () {});
          }

          observer.unobserve(wrapper);
        });
      }, { threshold: 0.6 });

      observer.observe(wrapper);
    }

    // inițial
    document.querySelectorAll('video.js-media-item-video')
      .forEach(setup);
    document.querySelectorAll('.js-product-media-deferred-video')
      .forEach(setupDeferred);

    // video-uri injectate ulterior
    const mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'VIDEO' && n.classList.contains('js-media-item-video')) {
            setup(n);
          }
          if (n.classList?.contains('js-product-media-deferred-video')) {
            setupDeferred(n);
          }
          n.querySelectorAll?.('video.js-media-item-video').forEach(setup);
          n.querySelectorAll?.('.js-product-media-deferred-video').forEach(setupDeferred);
        });
      });
    });

    mo.observe(document.body, { childList: true, subtree: true });

    /* ===== ARM AUTOPLAY DUPĂ PRIMA INTERACȚIUNE ===== */
    const armAutoplay = () => {
      document.querySelectorAll('video.js-media-item-video').forEach(v => {
        if (!v.paused) return;
        v.play().catch(() => {});
      });
      window.removeEventListener('scroll', armAutoplay);
      window.removeEventListener('touchstart', armAutoplay);
    };

    window.addEventListener('scroll', armAutoplay, { once: true });
    window.addEventListener('touchstart', armAutoplay, { once: true });
  }

  /* =========================================================
     PRODUCT GALLERY DIALOG (MOBILE) - SWIPE + AUTOPLAY
     ========================================================= */
  function initMobileGalleryDialog() {
    var mobileMq = window.matchMedia && window.matchMedia('(max-width: 749px)');
    if (!mobileMq) return;

    function forceVideoPaint(video) {
      if (!video) return;
      video.style.transform = 'translateZ(0)';
      video.style.webkitTransform = 'translateZ(0)';
      video.style.backfaceVisibility = 'hidden';
      video.style.webkitBackfaceVisibility = 'hidden';
      video.offsetHeight;
    }

    function prepareInlineVideo(video) {
      if (!video) return;
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.playsInline = true;
      video.autoplay = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('autoplay', '');
      video.removeAttribute('poster');
      forceVideoPaint(video);
      if (!video.dataset.entinoDialogPrimed) {
        video.dataset.entinoDialogPrimed = 'true';
        video.addEventListener('playing', function () {
          video.removeAttribute('poster');
          forceVideoPaint(video);
        });
      }
    }

    function revealDialogVideo(wrapper) {
      if (!wrapper) return;
      wrapper.classList.add('is-dialog-autoplay');
      var placeholder = wrapper.querySelector('.js-product-media-item-deferred-video-image');
      if (placeholder) {
        placeholder.style.display = 'none';
        placeholder.setAttribute('hidden', 'hidden');
      }
    }

    function tryPlayDeferredMedia(wrapper) {
      var video = wrapper.querySelector('video.js-media-item-video');
      if (video) {
        revealDialogVideo(wrapper);
        prepareInlineVideo(video);
        if (video.readyState >= 2) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.addEventListener('loadeddata', function () {
            prepareInlineVideo(video);
            video.play().catch(function () {});
          }, { once: true });
        }
        return true;
      }

      var youtube = wrapper.querySelector('.js-media-item-youtube');
      if (youtube && youtube.contentWindow) {
        revealDialogVideo(wrapper);
        try {
          youtube.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } catch (e) {}
        return true;
      }

      var vimeo = wrapper.querySelector('.js-media-item-vimeo');
      if (vimeo && vimeo.contentWindow) {
        revealDialogVideo(wrapper);
        try {
          vimeo.contentWindow.postMessage('{"method":"play"}', '*');
        } catch (e) {}
        return true;
      }

      return false;
    }

    function observeDeferredMedia(wrapper) {
      if (!wrapper || wrapper.dataset.entinoDeferredObserve) return;
      wrapper.dataset.entinoDeferredObserve = 'true';

      var mo = new MutationObserver(function () {
        tryPlayDeferredMedia(wrapper);
      });

      mo.observe(wrapper, { childList: true, subtree: true });

      var attrObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'loaded' && wrapper.hasAttribute('loaded')) {
            tryPlayDeferredMedia(wrapper);
          }
        });
      });

      attrObserver.observe(wrapper, { attributes: true, attributeFilter: ['loaded'] });
    }

    function playDeferredVideo(wrapper) {
      if (!wrapper) return;

      observeDeferredMedia(wrapper);

      if (typeof wrapper.loadContent === 'function' && !wrapper.hasAttribute('loaded')) {
        wrapper.loadContent();
      }

      if (!wrapper.hasAttribute('loaded')) {
        wrapper.querySelector('.js-product-media-item-deferred-video-image')?.click();
      }

      if (tryPlayDeferredMedia(wrapper)) return;

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (tryPlayDeferredMedia(wrapper) || attempts > 12) {
          clearInterval(timer);
        }
      }, 200);
    }

    function playActiveDialogVideo(dialog) {
      if (!dialog) return;
      var activeSlide = dialog.querySelector('.js-gallery-slide.is-active-gallery-slide');
      if (!activeSlide) return;
      var wrapper = activeSlide.querySelector('.js-product-media-deferred-video');
      if (!wrapper) return;
      playDeferredVideo(wrapper);
    }

    function attachSwipe(container, dialog) {
      if (!container || container.dataset.entinoSwipeInit) return;
      container.dataset.entinoSwipeInit = 'true';

      var startX = 0;
      var startY = 0;
      var tracking = false;

      container.addEventListener('touchstart', function (event) {
        if (!mobileMq.matches) return;
        if (!event.touches || event.touches.length !== 1) return;
        tracking = true;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      container.addEventListener('touchend', function (event) {
        if (!tracking || !mobileMq.matches) return;
        tracking = false;
        if (!event.changedTouches || !event.changedTouches.length) return;
        var endX = event.changedTouches[0].clientX;
        var endY = event.changedTouches[0].clientY;
        var deltaX = endX - startX;
        var deltaY = endY - startY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        var target = deltaX < 0
          ? dialog.querySelector('.js-slide-next-btn')
          : dialog.querySelector('.js-slide-prev-btn');
        if (target && !target.hasAttribute('disabled')) {
          target.click();
        }
      }, { passive: true });

      container.addEventListener('touchcancel', function () {
        tracking = false;
      }, { passive: true });
    }

    document.querySelectorAll('sht-dialog[id^="dialogProductGallery"]').forEach(function (dialog) {
      if (dialog.dataset.entinoGalleryDialogInit) return;
      dialog.dataset.entinoGalleryDialogInit = 'true';

      dialog.addEventListener('opening', function () {
        if (!mobileMq.matches) return;
        var slidesContainer = dialog.querySelector('.dialog-gallery-slides');
        if (slidesContainer) {
          attachSwipe(slidesContainer, dialog);
        }
        playActiveDialogVideo(dialog);
      });

      dialog.addEventListener('click', function (event) {
        if (!mobileMq.matches) return;
        var trigger = event.target.closest('.js-slide-prev-btn, .js-slide-next-btn, .js-gallery-btn-thumb');
        if (!trigger) return;
        playActiveDialogVideo(dialog);
      });
    });
  }

  /* =========================================================
     VIDEO BANNER HOMEPAGE – pornește automat și pe desktop
     ========================================================= */
  /* =========================================================
     PRODUCT GALLERY DIALOG (DESKTOP) - ZOOM SCALE
     ========================================================= */
  function initDialogZoomScale() {
    if (!window.customElements) return;
    var Zoom = customElements.get('sht-zoom');
    if (!Zoom || Zoom.prototype.__entinoDialogZoomPatched) return;
    Zoom.prototype.__entinoDialogZoomPatched = true;

    var originalInit = Zoom.prototype.init;
    var originalZoomIn = Zoom.prototype.zoomIn;
    var originalZoomOut = Zoom.prototype.zoomOut;

    function setZoomOrigin(zoom, event) {
      if (!zoom || !zoom.image || !event) return;
      var rect = zoom.image.getBoundingClientRect();
      var x = (event.clientX - rect.left) / rect.width;
      var y = (event.clientY - rect.top) / rect.height;
      x = Math.max(0, Math.min(1, x));
      y = Math.max(0, Math.min(1, y));
      zoom.__entinoZoomOrigin = { x: x, y: y };
    }

    Zoom.prototype.init = function () {
      if (typeof originalInit === 'function') {
        originalInit.call(this);
      }

      if (this.__entinoDialogZoomBound || !this.image) return;
      this.__entinoDialogZoomBound = true;

      var zoom = this;
      this.image.addEventListener('pointerdown', function (event) {
        setZoomOrigin(zoom, event);
      }, true);
      this.image.addEventListener('mousedown', function (event) {
        setZoomOrigin(zoom, event);
      }, true);
      this.image.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        setZoomOrigin(zoom, event.touches[0]);
      }, { passive: true, capture: true });
    };

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function applyDialogZoomTransform(zoom) {
      if (!zoom || !zoom.image || !zoom.__entinoDialogZoom) return;
      var state = zoom.__entinoDialogZoom;
      zoom.image.style.transform = 'translate(' + state.panX + 'px, ' + state.panY + 'px) scale(' + state.scale + ')';
    }

    function bindDialogZoomPan(zoom) {
      if (!zoom || zoom.__entinoDialogZoomPanBound || !zoom.container) return;
      zoom.__entinoDialogZoomPanBound = true;

      zoom.__entinoDialogZoomWheel = function (event) {
        if (!zoom.image || !zoom.image.hasAttribute('zoomed') || !zoom.__entinoDialogZoom) return;
        event.preventDefault();

        var state = zoom.__entinoDialogZoom;
        var deltaX = event.deltaX || 0;
        var deltaY = event.deltaY || 0;

        state.panX = clamp(state.panX - deltaX, state.minPanX, state.maxPanX);
        state.panY = clamp(state.panY - deltaY, state.minPanY, state.maxPanY);
        applyDialogZoomTransform(zoom);
      };

      zoom.container.addEventListener('wheel', zoom.__entinoDialogZoomWheel, { passive: false });
    }

    Zoom.prototype.zoomIn = function () {
      var dialog = this.closest('sht-dialog[id^="dialogProductGallery"]');
      if (dialog && window.matchMedia('(min-width: 769px)').matches) {
        if (!this.container || !this.image) return;

        var scale = parseFloat(getComputedStyle(dialog).getPropertyValue('--dialog-zoom-scale'));
        if (!scale || Number.isNaN(scale)) {
          scale = 2;
        }

        var origin = this.__entinoZoomOrigin || { x: 0.5, y: 0.5 };
        var baseWidth = this.image.offsetWidth;
        var baseHeight = this.image.offsetHeight;
        var containerWidth = this.container.clientWidth;
        var containerHeight = this.container.clientHeight;
        var naturalWidth = this.image.naturalWidth || baseWidth;
        var naturalHeight = this.image.naturalHeight || baseHeight;
        var imageRatio = naturalWidth && naturalHeight ? naturalWidth / naturalHeight : baseWidth / baseHeight;
        var containerRatio = containerWidth / containerHeight;
        var contentWidth = containerWidth;
        var contentHeight = containerHeight;

        if (imageRatio > containerRatio) {
          contentWidth = containerWidth;
          contentHeight = containerWidth / imageRatio;
        } else {
          contentHeight = containerHeight;
          contentWidth = containerHeight * imageRatio;
        }

        var contentLeft = (containerWidth - contentWidth) / 2;
        var contentTop = (containerHeight - contentHeight) / 2;
        var originElementX = origin.x * containerWidth;
        var originElementY = origin.y * containerHeight;
        var originContentX = clamp((originElementX - contentLeft) / contentWidth, 0, 1);
        var originContentY = clamp((originElementY - contentTop) / contentHeight, 0, 1);
        var focusX = contentLeft + originContentX * contentWidth;
        var focusY = contentTop + originContentY * contentHeight;
        var scaledWidth = contentWidth * scale;
        var scaledHeight = contentHeight * scale;
        var bodyEl = dialog.querySelector('.dialog__body');
        var bodyStyles = bodyEl ? getComputedStyle(bodyEl) : null;
        var padLeft = bodyStyles ? parseFloat(bodyStyles.paddingLeft) || 0 : 0;
        var padRight = bodyStyles ? parseFloat(bodyStyles.paddingRight) || 0 : 0;
        var padTop = bodyStyles ? parseFloat(bodyStyles.paddingTop) || 0 : 0;
        var padBottom = bodyStyles ? parseFloat(bodyStyles.paddingBottom) || 0 : 0;
        var panSlackX = padLeft + padRight;
        var extraPanSlack = 480;
        var panSlackY = padTop + padBottom + extraPanSlack;

        var minPanX = containerWidth - scale * (contentLeft + contentWidth) - panSlackX;
        var maxPanX = -scale * contentLeft + panSlackX;
        var minPanY = containerHeight - scale * (contentTop + contentHeight) - panSlackY;
        var maxPanY = -scale * contentTop + panSlackY;

        var panX = (containerWidth / 2) - (scale * focusX);
        var panY = (containerHeight / 2) - (scale * focusY);
        panX = clamp(panX, minPanX, maxPanX);
        panY = clamp(panY, minPanY, maxPanY);

        this.__entinoDialogZoom = {
          scale: scale,
          panX: panX,
          panY: panY,
          scaledWidth: scaledWidth,
          scaledHeight: scaledHeight,
          minPanX: minPanX,
          maxPanX: maxPanX,
          minPanY: minPanY,
          maxPanY: maxPanY
        };

        this.image.style.transformOrigin = '0 0';
        this.image.style.transition = 'transform 0.2s ease';
        this.image.style.cursor = 'zoom-out';
        this.image.style.width = '100%';
        this.image.style.height = '100%';
        this.image.style.objectFit = 'contain';
        this.image.setAttribute('zoomed', '');
        dialog.classList.add('is-dialog-zoomed');
        this.container.style.overflow = 'visible';
        this.container.classList.add('is-dialog-zoomed');

        applyDialogZoomTransform(this);
        bindDialogZoomPan(this);
        return;
      }

      originalZoomIn.call(this);
    };

    Zoom.prototype.zoomOut = function () {
      var dialog = this.closest('sht-dialog[id^="dialogProductGallery"]');
      if (dialog && window.matchMedia('(min-width: 769px)').matches) {
        if (!this.image || !this.container) return;
        originalZoomOut.call(this);
        this.image.style.transform = '';
        this.image.style.transformOrigin = '';
        this.image.style.transition = '';
        this.container.style.overflow = '';
        dialog.classList.remove('is-dialog-zoomed');
        this.container.classList.remove('is-dialog-zoomed');
        this.__entinoDialogZoom = null;
        if (this.__entinoDialogZoomWheel) {
          this.container.removeEventListener('wheel', this.__entinoDialogZoomWheel);
        }
        this.__entinoDialogZoomWheel = null;
        this.__entinoDialogZoomPanBound = false;
        return;
      }

      originalZoomOut.call(this);
    };
  }

  if (window.customElements) {
    if (customElements.get('sht-zoom')) {
      initDialogZoomScale();
    } else {
      customElements.whenDefined('sht-zoom').then(initDialogZoomScale);
    }
  }

  function forceInitialVideoBannerPlay() {
    // forțează recalcularea viewport-ului (ca un micro-scroll virtual)
    setTimeout(function () {
      window.dispatchEvent(new Event('scroll'));
    }, 150);
  }

  /* =========================================================
     WELCOME10 MODAL
     ========================================================= */
  function showWelcome10Modal() {
    if (document.querySelector('.welcome10-overlay')) return;

    var overlay = document.createElement('div');
    overlay.className = 'welcome10-overlay';
    overlay.innerHTML = `
      <div class="welcome10-modal" role="dialog" aria-modal="true" aria-label="Cod reducere">
        <button class="welcome10-close" type="button" aria-label="Închide">×</button>
        <div class="welcome10-brand">ENTINO</div>
        <h3 class="welcome10-title">Discount de 10%</h3>
        <p class="welcome10-text">Codul tău de reducere este:</p>
        <div class="welcome10-code">WELCOME10</div>
        <button class="welcome10-copy" type="button">Copiază codul</button>
        <p class="welcome10-note">Folosește codul la finalizarea comenzii (checkout).</p>
      </div>
    `;
    document.body.appendChild(overlay);

    function close() {
      overlay.remove();
    }

    overlay.querySelector('.welcome10-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    overlay.querySelector('.welcome10-copy').addEventListener('click', function () {
      var btn = this;
      try {
        navigator.clipboard.writeText('WELCOME10');
        btn.textContent = 'Copiat ✓';
      } catch (e) {
        btn.textContent = 'WELCOME10';
      }
      setTimeout(function () {
        btn.textContent = 'Copiază codul';
      }, 2000);
    });
  }

  function initWelcome10() {
    var hasPosted = window.location.search.indexOf('customer_posted=true') !== -1;
    if (!hasPosted) return;

    showWelcome10Modal();

    if (history && history.replaceState) {
      history.replaceState({}, document.title, window.location.pathname + window.location.hash);
    }
  }

  /* =========================================================
     SAFARI – fix meniu colecții
     ========================================================= */
function fixSafariDesktopCollectionsMenu() {
  var ua = navigator.userAgent;
  var isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  var isIOS = /iPad|iPhone|iPod/.test(ua);
  if (!isSafari || isIOS) return;

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.zi-2[href^="/collections/"]');
    if (!a) return;

    // NU mai omorâm alte click-uri
    e.preventDefault();

    // navigare sigură
    window.location.href = a.href;
  }, true); // capture rămâne OK
}


  /* =========================================================
     GHID DE MĂRIMI – mutare + reatașare
     ========================================================= */
  var sizeGuideHTML = null;
  var sizeGuideObserver = null;

  function moveSizeGuide() {
    var picker = document.querySelector('.js-variant-picker');
    if (!picker) return;

    var legend = picker.querySelector('legend.product-option__name');
    if (!legend) return;

    var guideWrap = document.querySelector('.product__info.ord-4');

    if (!sizeGuideHTML && guideWrap) {
      sizeGuideHTML = guideWrap.outerHTML;
    }

    if (!guideWrap && sizeGuideHTML) {
      var existingInLegend = legend.querySelector('.product__info.ord-4');
      if (!existingInLegend) {
        legend.insertAdjacentHTML('beforeend', sizeGuideHTML);
      }
      guideWrap = legend.querySelector('.product__info.ord-4');
    }

    if (!guideWrap) return;

    if (!legend.contains(guideWrap)) {
      legend.appendChild(guideWrap);
    }

    guideWrap.classList.add('size-guide-moved');
  }

  function observeSizePicker() {
    var picker = document.querySelector('.js-variant-picker');
    if (!picker) return;
    if (sizeGuideObserver) return;

    sizeGuideObserver = new MutationObserver(function () {
      requestAnimationFrame(moveSizeGuide);
    });

    sizeGuideObserver.observe(picker, { childList: true, subtree: true });

    picker.addEventListener('change', function () {
      setTimeout(moveSizeGuide, 0);
    });
  }

  function setFixedViewportHeight() {
  // înălțimea REALĂ a viewport-ului la load
  var vh = window.innerHeight;
  document.documentElement.style.setProperty('--vh-fixed', vh + 'px');
}

  /* =========================================================
     HOMEPAGE SCROLL REVEAL (repeat on re-entry)
     ========================================================= */
  var homepageRevealObserver = null;

  function initHomepageScrollReveal() {
    var body = document.body;
    if (!body || !body.classList.contains('template-index')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var scope = document.getElementById('mainContent');
    if (!scope) return;

    if (homepageRevealObserver) {
      homepageRevealObserver.disconnect();
    }

    homepageRevealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.15) {
          el.classList.add('animated');
          return;
        }
        if (!entry.isIntersecting && entry.intersectionRatio === 0) {
          el.classList.remove('animated');
        }
      });
    }, { threshold: [0, 0.15] });

    scope.querySelectorAll('.js-animate, .js-seq-animate').forEach(function (el) {
      homepageRevealObserver.observe(el);
    });
  }

  /* =========================================================
     PRODUCT INFO SMART STICKY (DESKTOP)
     ========================================================= */
  var smartStickyState = null;

  function initSmartStickyProductInfo() {
    if (smartStickyState) {
      smartStickyState.refresh();
      return;
    }

    var desktopMq = window.matchMedia('(min-width: 1025px)');
    var instances = [];
    var lastScrollY = window.scrollY || window.pageYOffset;
    var lastDirection = 'down';
    var ticking = false;
    var pendingUpdate = false;

    function applyHeaderOffset(inst, headerOffset) {
      var offset = headerOffset > 0 ? Math.round(headerOffset) + 'px' : '';
      inst.sidebar.style.top = offset;
      inst.sidebar.style.insetBlockStart = offset;
    }

    function resetInstance(inst, headerOffset) {
      inst.sidebar.classList.remove('is-smart-sticky');
      applyHeaderOffset(inst, headerOffset || 0);
      inst.inner.style.transform = '';
      inst.currentTranslate = 0;
    }

    function measureInstance(inst) {
      var scrollY = window.scrollY || window.pageYOffset;
      var containerRect = inst.container.getBoundingClientRect();
      inst.containerTop = containerRect.top + scrollY;
      inst.containerBottom = inst.containerTop + inst.container.offsetHeight;
      inst.sidebarTop = inst.containerTop;
      inst.sidebarHeight = inst.inner.offsetHeight;
      inst.viewportHeight = window.innerHeight;
      inst.maxTranslate = inst.containerBottom - inst.sidebarTop - inst.sidebarHeight;
      if (inst.maxTranslate < 0) {
        inst.maxTranslate = 0;
      }
      inst.active = inst.sidebarHeight > inst.viewportHeight;
      inst.needsMeasure = false;
    }

    function getHeaderOffset() {
      var stickyHeader = document.querySelector('sht-sticky-header');
      var header = stickyHeader ? stickyHeader.querySelector('.section-header') || stickyHeader : null;
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      if (!rect || rect.height <= 0) return 0;
      var visibleTop = Math.max(0, rect.top);
      var visibleBottom = Math.min(rect.bottom, rect.height);
      var visible = visibleBottom - visibleTop;
      return visible > 0 ? visible : 0;
    }

    function applyInstance(inst, direction, scrollY, headerOffset) {
      if (!inst.active) {
        resetInstance(inst, headerOffset);
        return;
      }

      inst.sidebar.classList.add('is-smart-sticky');
      applyHeaderOffset(inst, 0);

      var edgeThreshold = 0.75;
      var growthThreshold = 4;
      var unlockDistance = 8;

      if (inst.edgeLock === 'bottom') {
        if (direction === 'up') {
          if (scrollY <= inst.lockScrollY - unlockDistance) {
            inst.edgeLock = null;
          } else {
            return;
          }
        } else if (Math.abs(inst.maxTranslate - inst.currentTranslate) < growthThreshold) {
          return;
        } else {
          inst.edgeLock = null;
        }
      }

      if (inst.edgeLock === 'top') {
        if (direction === 'down') {
          if (scrollY >= inst.lockScrollY + unlockDistance) {
            inst.edgeLock = null;
          } else {
            return;
          }
        } else if (inst.currentTranslate < growthThreshold) {
          return;
        } else {
          inst.edgeLock = null;
        }
      }

      if (inst.currentTranslate > inst.maxTranslate) {
        inst.currentTranslate = inst.maxTranslate;
      }
      if (inst.currentTranslate < 0) {
        inst.currentTranslate = 0;
      }

      var nextTranslate = inst.currentTranslate;

      if (direction === 'down') {
        var targetDown = scrollY + (inst.viewportHeight - headerOffset) - inst.sidebarHeight - inst.sidebarTop;
        if (targetDown > nextTranslate) {
          nextTranslate = Math.min(targetDown, inst.maxTranslate);
        }
      } else {
        var targetUp = scrollY - inst.sidebarTop + headerOffset;
        if (targetUp < nextTranslate) {
          nextTranslate = Math.max(targetUp, 0);
        }
      }

      if (nextTranslate < 0.5) {
        nextTranslate = 0;
      }
      if (inst.maxTranslate - nextTranslate < 0.5) {
        nextTranslate = inst.maxTranslate;
      }

      var maxDelta = Math.abs(inst.maxTranslate - (inst.lastMaxTranslate || inst.maxTranslate));
      inst.lastMaxTranslate = inst.maxTranslate;

      if (Math.abs(nextTranslate - inst.currentTranslate) < 0.5 && maxDelta < 0.5) {
        return;
      }

      inst.currentTranslate = nextTranslate;
      inst.inner.style.transform = 'translateY(' + inst.currentTranslate.toFixed(2) + 'px)';

      if (direction === 'down' && inst.currentTranslate >= inst.maxTranslate - edgeThreshold) {
        inst.edgeLock = 'bottom';
        inst.lockScrollY = scrollY;
      } else if (direction === 'up' && inst.currentTranslate <= edgeThreshold) {
        inst.edgeLock = 'top';
        inst.lockScrollY = scrollY;
      } else {
        inst.edgeLock = null;
        inst.lockScrollY = null;
      }
    }

    function updateAll(direction) {
      if (!desktopMq.matches) {
        instances.forEach(function (inst) {
          resetInstance(inst, 0);
        });
        return;
      }

      var scrollY = window.scrollY || window.pageYOffset;
      var headerOffset = getHeaderOffset();
      var dir = direction || (headerOffset > 0 ? 'up' : lastDirection);

      instances.forEach(function (inst) {
        if (inst.needsMeasure) {
          measureInstance(inst);
          inst.edgeLock = null;
          inst.lockScrollY = null;
        }
        applyInstance(inst, dir, scrollY, headerOffset);
      });
    }

    function scheduleUpdate() {
      if (pendingUpdate) return;
      pendingUpdate = true;
      window.requestAnimationFrame(function () {
        pendingUpdate = false;
        updateAll();
      });
    }

    function handleScroll() {
      var scrollY = window.scrollY || window.pageYOffset;
      var delta = scrollY - lastScrollY;
      if (Math.abs(delta) < 1) {
        return;
      }
      lastDirection = delta > 0 ? 'down' : 'up';
      lastScrollY = scrollY;
      updateAll(lastDirection);
    }

    function requestTick() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        handleScroll();
      });
    }

    function onScroll() {
      requestTick();
    }

    function onResize() {
      lastScrollY = window.scrollY || window.pageYOffset;
      updateAll(lastDirection);
    }

    function buildInstances() {
      instances.forEach(function (inst) {
        if (inst.resizeObserver) {
          inst.resizeObserver.disconnect();
        }
      });

      instances = [];

      document.querySelectorAll('.main-product .product-details').forEach(function (container) {
        var sidebar = container.querySelector('.product__info-wrapper.product-detail__item--sticky');
        if (!sidebar) return;
        var inner = sidebar.querySelector('.main-product-info-container');
        if (!inner) return;

        var inst = {
          container: container,
          sidebar: sidebar,
          inner: inner,
          currentTranslate: 0,
          active: false,
          resizeObserver: null,
          edgeLock: null,
          lockScrollY: null,
          needsMeasure: true
        };

        if (window.ResizeObserver) {
          inst.resizeObserver = new ResizeObserver(function () {
            inst.needsMeasure = true;
            inst.edgeLock = null;
            inst.lockScrollY = null;
            scheduleUpdate();
          });
          inst.resizeObserver.observe(inner);
          inst.resizeObserver.observe(container);
        }

        instances.push(inst);
      });
    }

    buildInstances();
    updateAll(lastDirection);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    if (desktopMq.addEventListener) {
      desktopMq.addEventListener('change', onResize);
    } else if (desktopMq.addListener) {
      desktopMq.addListener(onResize);
    }

    smartStickyState = {
      refresh: function () {
        buildInstances();
        updateAll('down');
      }
    };
  }

  /* =========================================================
     WISHLIST (localStorage)
     ========================================================= */
  var wishlistStorageKey = 'entino:wishlist';
  var wishlistInitialized = false;
  var wishlistToastTimeout = null;

  function getWishlistItems() {
    var raw = null;
    try {
      raw = window.localStorage.getItem(wishlistStorageKey);
    } catch (e) {
      return [];
    }
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return typeof item === 'string' && item.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function setWishlistItems(items) {
    var map = {};
    var normalized = [];
    items.forEach(function (item) {
      if (typeof item !== 'string' || item.length === 0) return;
      if (map[item]) return;
      map[item] = true;
      normalized.push(item);
    });
    try {
      window.localStorage.setItem(wishlistStorageKey, JSON.stringify(normalized));
    } catch (e) {
      return normalized;
    }
    return normalized;
  }

  function updateWishlistCount(items) {
    var count = items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var target = el.querySelector('.cart-count-number') || el.querySelector('.wishlist-count-number');
      if (target) {
        target.textContent = count > 0 ? count : '';
      } else {
        el.textContent = count > 0 ? count : '';
      }
      el.classList.toggle('is-empty', count === 0);
      el.toggleAttribute('hidden', count === 0);
    });
    document.querySelectorAll('[data-wishlist-indicator]').forEach(function (el) {
      el.classList.toggle('is-active', count > 0);
    });
  }

  function setWishlistButtonState(button, isActive) {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    var label = isActive ? button.getAttribute('data-wishlist-label-remove') : button.getAttribute('data-wishlist-label-add');
    if (label) {
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    }
    var textAdd = button.getAttribute('data-wishlist-text-add');
    var textRemove = button.getAttribute('data-wishlist-text-remove');
    if (textAdd || textRemove) {
      var textTarget = button.querySelector('[data-wishlist-text]') || button.querySelector('.js-wishlist-btn-text');
      if (textTarget) {
        textTarget.textContent = isActive ? (textRemove || textAdd || '') : (textAdd || textRemove || '');
      }
    }
  }

  function updateWishlistButtons(items) {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-wishlist-handle');
      if (!handle) return;
      setWishlistButtonState(button, items.indexOf(handle) !== -1);
    });
  }

  function toggleWishlistItem(handle) {
    var items = getWishlistItems();
    var index = items.indexOf(handle);
    var isAdded = index === -1;
    if (index === -1) {
      items.push(handle);
    } else {
      items.splice(index, 1);
    }
    items = setWishlistItems(items);
    updateWishlistButtons(items);
    updateWishlistCount(items);
    renderWishlistContainers(items);
    showWishlistToast(isAdded ? 'Produsul a fost adaugat la Favorite' : 'Produsul a fost sters de la Favorite');
    return items;
  }

  function joinRootPath(root, path) {
    var safeRoot = root || '/';
    if (safeRoot.slice(-1) !== '/') safeRoot += '/';
    return safeRoot + path.replace(/^\//, '');
  }

  function getShopRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function formatMoney(cents) {
    if (window.SHTHelper && typeof window.SHTHelper.formatMoney === 'function') {
      return window.SHTHelper.formatMoney(cents);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function buildWishlistPriceHtml(product) {
    var price = formatMoney(product.price);
    var compareAt = product.compare_at_price;
    var priceClass = product.available ? '' : ' price--sold-out';
    if (compareAt && compareAt > product.price) {
      return '' +
        '<span class="price' + priceClass + '">' +
          '<span class="price__sale d-flex middle-xs fw-wrap">' +
            '<span class="price-item price-item--last mt-4 mb-4 d-inline-block mr-8">' + price + '</span>' +
            '<span class="d-inline-block"><s class="price-item price-item--regular color-light subtext">' + formatMoney(compareAt) + '</s></span>' +
          '</span>' +
        '</span>';
    }
    return '' +
      '<span class="price' + priceClass + '">' +
        '<span class="price__regular d-block">' +
          '<span class="price-item price-item--regular price-item--last mt-4 mb-4 d-inline-block">' + price + '</span>' +
        '</span>' +
      '</span>';
  }

  function fetchWishlistProduct(handle) {
    var url = joinRootPath(getShopRoot(), 'products/' + handle + '.js');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function buildWishlistCard(template, product) {
    var content = template.content ? template.content.cloneNode(true) : template.cloneNode(true);
    var card = content.querySelector('[data-wishlist-card]');
    var link = content.querySelector('[data-wishlist-link]');
    var image = content.querySelector('[data-wishlist-image]');
    var title = content.querySelector('[data-wishlist-title]');
    var price = content.querySelector('[data-wishlist-price]');
    var button = content.querySelector('[data-wishlist-toggle]');
    var productUrl = joinRootPath(getShopRoot(), 'products/' + product.handle);

    if (card) card.setAttribute('data-wishlist-handle', product.handle);
    if (link) link.setAttribute('href', productUrl);
    if (title) {
      title.textContent = product.title;
      title.setAttribute('href', productUrl);
    }
    if (image) {
      var imageUrl = product.featured_image || (product.images && product.images[0]) || '';
      image.setAttribute('src', imageUrl);
      image.setAttribute('alt', product.title || '');
    }
    if (price) {
      price.innerHTML = buildWishlistPriceHtml(product);
    }
    if (button) {
      button.setAttribute('data-wishlist-handle', product.handle);
      button.setAttribute('data-wishlist-id', product.id);
    }

    return content;
  }

  function renderWishlistContainers(forcedItems) {
    var containers = document.querySelectorAll('[data-wishlist-container]');
    if (!containers.length) return;

    var items = forcedItems || getWishlistItems();
    if (!items.length) {
      containers.forEach(function (container) {
        var grid = container.querySelector('[data-wishlist-grid]');
        var emptyState = container.querySelector('[data-wishlist-empty]');
        if (grid) grid.innerHTML = '';
        if (emptyState) emptyState.removeAttribute('hidden');
      });
      return;
    }

    var requests = items.map(function (handle) {
      return fetchWishlistProduct(handle);
    });

    Promise.all(requests).then(function (products) {
      containers.forEach(function (container) {
        var grid = container.querySelector('[data-wishlist-grid]');
        var emptyState = container.querySelector('[data-wishlist-empty]');
        var template = container.querySelector('[data-wishlist-card-template]');
        if (!grid || !template) return;

        var fragment = document.createDocumentFragment();
        var hasProducts = false;
        products.forEach(function (product) {
          if (!product) return;
          hasProducts = true;
          fragment.appendChild(buildWishlistCard(template, product));
        });

        grid.innerHTML = '';
        if (hasProducts) {
          grid.appendChild(fragment);
          if (emptyState) emptyState.setAttribute('hidden', 'hidden');
        } else if (emptyState) {
          emptyState.removeAttribute('hidden');
        }
      });

      updateWishlistButtons(items);
    });
  }

  function getWishlistModal() {
    return document.querySelector('[data-wishlist-modal]');
  }

  function openWishlistModal() {
    var modal = getWishlistModal();
    if (!modal) return;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('wishlist-modal-open');
    renderWishlistContainers(getWishlistItems());
  }

  function closeWishlistModal() {
    var modal = getWishlistModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.classList.remove('wishlist-modal-open');
  }

  function getWishlistToast() {
    return document.querySelector('[data-wishlist-toast]');
  }

  function showWishlistToast(message) {
    var toast = getWishlistToast();
    if (!toast) return;
    var text = toast.querySelector('[data-wishlist-toast-text]');
    if (text) text.textContent = message;
    toast.hidden = false;
    toast.classList.add('is-visible');
    if (wishlistToastTimeout) {
      clearTimeout(wishlistToastTimeout);
    }
    wishlistToastTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
      toast.hidden = true;
    }, 3000);
  }

  function initWishlist() {
    if (wishlistInitialized) {
      var items = getWishlistItems();
      updateWishlistButtons(items);
      updateWishlistCount(items);
      renderWishlistContainers(items);
      return;
    }

    wishlistInitialized = true;
    var items = getWishlistItems();
    updateWishlistButtons(items);
    updateWishlistCount(items);
    renderWishlistContainers(items);

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-wishlist-toggle]');
      if (!button) return;
      var handle = button.getAttribute('data-wishlist-handle');
      if (!handle) return;
      event.preventDefault();
      toggleWishlistItem(handle);
    });

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-wishlist-open]');
      if (openTrigger) {
        event.preventDefault();
        openWishlistModal();
        return;
      }
      var closeTrigger = event.target.closest('[data-wishlist-close]');
      if (closeTrigger) {
        event.preventDefault();
        closeWishlistModal();
      }
      var toastClose = event.target.closest('[data-wishlist-toast-close]');
      if (toastClose) {
        event.preventDefault();
        var toast = getWishlistToast();
        if (toast) {
          toast.classList.remove('is-visible');
          toast.hidden = true;
        }
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeWishlistModal();
      }
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== wishlistStorageKey) return;
      var items = getWishlistItems();
      updateWishlistButtons(items);
      updateWishlistCount(items);
      renderWishlistContainers(items);
    });
  }

  /* =========================================================
     PREDICTIVE SEARCH - title only
     ========================================================= */
  function forcePredictiveSearchTitleOnly() {
    if (!window.customElements || !customElements.whenDefined) return;

    customElements.whenDefined('sht-predictive-srch').then(function () {
      var Predictive = customElements.get('sht-predictive-srch');
      if (!Predictive || !Predictive.prototype || Predictive.prototype.__entinoTitleOnly) return;

      var originalFetch = Predictive.prototype.fetchResults;

      Predictive.prototype.fetchResults = async function (term) {
        var baseUrl = (this.url && this.url.searchUrl) || (window.routes && window.routes.predictive_search_url);
        if (!baseUrl) {
          if (typeof originalFetch === 'function') {
            return originalFetch.call(this, term);
          }
          return '';
        }

        var requestUrl = baseUrl +
          '?q=' + encodeURIComponent(term) +
          '&resources[limit_scope]=each' +
          '&section_id=predictive-search' +
          '&resources[options][fields]=title';

        this.toggleLoading(true);
        this.toggleLoadingContainer(true);

        try {
          var response = await fetch(requestUrl);
          if (!response.ok) {
            throw new Error(response.status);
          }
          var text = await response.text();
          this.toggleLoading(false);
          this.toggleLoadingContainer(false);
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var section = doc.querySelector('#shopify-section-predictive-search');
          return section ? section.innerHTML : '';
        } catch (error) {
          console.error(error);
          this.toggleLoading(false);
          this.toggleLoadingContainer(false);
          return '';
        }
      };

      Predictive.prototype.__entinoTitleOnly = true;
    });
  }

  /* =========================================================
     INIT GENERAL
     ========================================================= */
  function initAll() {
    initWelcome10();
    moveSizeGuide();
    observeSizePicker();
    fixSafariDesktopCollectionsMenu();
    initProductVideos();
    initMobileGalleryDialog();
    forceInitialVideoBannerPlay();
    setFixedViewportHeight();
    initHomepageScrollReveal();
    initSmartStickyProductInfo();
    initWishlist();
    forcePredictiveSearchTitleOnly();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Reinițializare pentru secțiuni Shopify (variant change / lazy load)
  document.addEventListener('shopify:section:load', initProductVideos);
  document.addEventListener('shopify:section:load', initMobileGalleryDialog);
  document.addEventListener('shopify:section:load', initHomepageScrollReveal);
  document.addEventListener('shopify:section:load', initSmartStickyProductInfo);
  document.addEventListener('shopify:section:load', initWishlist);

})();


